<script setup lang="ts">
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { Modal, Text, RadioButton } from "@ui-kit";

  const { selected_sort_id } = defineProps<{
    selected_sort_id: string;
  }>();
  const emit = defineEmits<{ (e: "close"): void; (e: "click:item", id: string): void }>();

  const i18n = useI18n();

  const items = computed(() => [
    { id: "default", label: i18n.t("По умолчанию") },
    { id: "amount", label: i18n.t("По сумме") },
    { id: "quantity", label: i18n.t("По штукам") },
  ]);

  const handleClickItem = (id: string) => {
    emit("click:item", id);
    emit("close");
  };
</script>

<template>
  <Modal close data-testid="moneymap-sort-modal" @onClose="emit('close')">
    <div class="moneymap__sort-header">
      <Text font="body-bold-18">{{ $t("Сортировка") }}</Text>
    </div>
    <div class="moneymap__sort-item-list">
      <div
        v-for="item in items"
        :key="item.id"
        class="moneymap__sort-item"
        :data-testid="`moneymap-sort-${item.id}`"
        @click="() => handleClickItem(item.id)"
      >
        <RadioButton :value="item.id" :label="item.label" :is-checked="item.id === selected_sort_id" />
      </div>
    </div>
  </Modal>
</template>

<style scoped>
  .moneymap__sort-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  .moneymap__sort-item-list {
    display: flex;
    flex-direction: column;
  }

  .moneymap__sort-item {
    padding: 12px 0;
  }
</style>
